import React from "react";

import classes from "./TimePeriodButton.module.scss";

const TimePeriodButton = props => {
  let className = props.selected
    ? [classes.timePeriodButton, classes.selected].join(" ")
    : classes.timePeriodButton;
  return (
    <div
      value={props.id}
      className={className}
      onClick={() => props.click(props.id)}
      style={{ right: props.right }}
    >
      {props.children}
    </div>
  );
};

export default TimePeriodButton;
